import { EnChapterType } from '@prisma/client'
import { ChapterTypeEnum } from 'src/enums/chapter-type.enum'
import { t } from './translate.helper'

export const getChapterTitle = (params: {
  tom?: string
  number: string | null
  type: EnChapterType
}) => {
  const { tom, number = '0', type } = params
  const text = tom ? t('Tom {tom}. ', { tom }) : ''

  if (type === EnChapterType.CHAPTER) {
    return text + t('Chapter {number}', { number })
  }

  const chapterLabel = ChapterTypeEnum.getLabels()[type]
  return `${text}${chapterLabel}${number ? ` ${number}` : ''}`
}
